import React from 'react'
import { Redirect } from 'react-router-dom'

const Finance = () => <Redirect to='/finance/disbursement' />

export default Finance
